import { createFileRoute } from '@tanstack/react-router';
import ImportManager from '@/pages/import/ImportManager';

export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/import')({
  component: ImportManager,
});